import HttpError from './HttpError';

export default class InvitationExistsError extends HttpError {}
